import React from "react";
import "../Menu.css";
import Footer from "./footer";
import Homecarousel from "./homecarousel";
import Navbar from "./navbar";

const SainathNaidu = () => {
  return (
    <>
      <Navbar />
      <Homecarousel />

      <div className="container">
        <center>
          <div>
            <h2 className="heading-p1">Sainath Naidu Paidipati</h2>
          </div>
          <div>
            <h6 className="heading-p2">
              Expert on IndGAP,GlobalG.A.P, Organic Schemes
            </h6>
          </div>
          <div>
            <img className="image" src="../images/sainathnaidu.jpg" alt="" />
          </div>
        </center>
      </div>
      <div className="row">
        <div className="col containerin">
          <b>Present</b>
          <br />
          <span>
            External expert on On- Farm production related standards like
            IndGAP, GlobalG.A.P, Organic NPOP 2024 , USDA NOP, PGS
            certification, Rainforest Alliance and Natural Farming.
          </span>
          <br />
          <br />
          <b>Past</b>
          <br />
          <span>
            Worked with TQ Cert India Pvt. Ltd (a TATA group company), an
            accredited certification body since April 2015 to 31-03-2024, on
            full time basis, as Certification In charge for various Pre farm
            Certification Schemes.
            <br />
            Worked with FoodCert Pvt Ltd, an accreditation body, since 2003 to
            March 2015 as In-house Inspector / Auditor for Primary pre-farm
            schemes – Organic, Global G.A.P, Ind G.A.P, voluntary certification
            scheme for medicinal plant produce. Overseeing post farm
            certification schemes like ISO 22000, HACCP, HCHI, Second Party
            Audits.
            <br /> Development Manager (Agri Finance), Govt. of India
            undertaking and associated with NABARD, Govt. of India overseeing
            appraisal of all Agri projects/ minor irrigation/ farm
            mechanization/Poultry/ Dairy/ Small scale industries and
            community-based projects (up to 2003).
          </span>
          <br />
          <br />
          <div style={{ marginBottom: "10px" }}>
            <b>International Exposure:</b>
            <ul className="ulstyle">
              <li>
                Associated with UNIDO project jointly with YES Bank: supply
                chain study of Cocoa in Ghana.
              </li>
              <li>
                Associated with FAO project as international consultant under
                SAARC Scheme for setting up of certification body (GAP)in
                Bangladesh during 2016.This exposure covered documentation
                support for ISO 17065, ISO 9001, ISO 19011and ISO 22000.
              </li>
              <li>
                Imparted training in Ghana on ultra-high density plantation
                scheme for Mango.
              </li>
            </ul>
          </div>
          <div style={{ marginBottom: "10px" }}>
            <b>Education:</b>
            <ul className="ulstyle">
              <li>B.Sc. in Agriculture.</li>
              <li>
                Successfully completed 5 days IATCA QMS Lead Auditor Training
                Course (ISO 9001:2000).
              </li>
              <li>
                Completed 3 days IRCA accredited Food Safety Management Systems
                (ISO 220002005) Auditor/Lead Auditor Conversion Training Course.
              </li>
            </ul>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default SainathNaidu;
